import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUser, selectGreenhouse, useGreenhouseActions } from 'state';
import { API } from '../../api';
import {
  Container,
  Table,
  TableHeader,
  TableRow,
  TableCell
} from './AlertsSettings.styles';
import { StyledSelect } from '../Scanning/Scanning.styles';
import { StyledInputText } from '../../components/_shared/Input';
import { StyledButton } from '../../components/FileUploader/FileUploader.styles';
import { padding } from 'polished';
import { Header } from '../Account/components/PageWrapper/PageWrapper.styles';
const AlertsSettings = () => {
  const user = useSelector(selectUser);
  const customer = user?.customer?.[0]?.external_id;
  const { locations, selectedGreenhouse } = useSelector(selectGreenhouse);
  const { getLocations } = useGreenhouseActions();
  useEffect(() => {
    if (!locations.length) getLocations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fieldOptions = [
    { name: 'Canopy Percentage', value: 'canopy_percentage' },
    { name: 'Induction per m²', value: 'induction_per_m2' },
    { name: 'Yellow Leaves per m²', value: 'yellow_leaves_per_m2' },
    { name: 'Brown Leaves per m²', value: 'brown_leaves_per_m2' }
  ];
  const checkTypes = [
    { name: 'Greater than previous', value: 'gtp' },
    { name: 'Less than previous', value: 'ltp' },
    { name: 'Greater than or equal', value: 'gte' },
    { name: 'Less than or equal', value: 'lte' }
  ];
  const [alerts, setAlerts] = useState([]);
  const [newAlert, setNewAlert] = useState({
    field: '',
    check_type: '',
    threshold: ''
  });
  const [logs, setLogs] = useState([]);

  const addAlert = () => {
    if (
      !newAlert.location__name ||
      !newAlert.field ||
      !newAlert.check_type ||
      !newAlert.threshold
    )
      return;
    createAlert(customer, newAlert);
    setNewAlert({ field: '', check_type: '', threshold: '' });
  };

  const updateAlertItem = (id, key, value) => {
    setAlerts(
      alerts.map(a => (a.id === id ? { ...a, [key]: value, modified: true } : a))
    );
  };
  const removeModified = id => {
    setAlerts(alerts.map(a => (a.id === id ? { ...a, modified: false } : a)));
  };

  const updateAlert = (id, alert) => {
    API.alert
      .updateAlert(id, 'canopy_detection', alert.check_type, alert.field, alert.threshold)
      .then(() => removeModified(id));
  };
  const createAlert = (customer, alert) => {
    API.alert
      .createAlert(
        customer,
        alert.location__name,
        'canopy_detection',
        alert.check_type,
        alert.field,
        alert.threshold
      )
      .then(() => getAlerts(customer, location));
  };

  const deleteAlert = (id, alert) => {
    API.alert
      .deleteAlert(id, 'canopy_detection', alert.check_type, alert.field, alert.threshold)
      .then(() => setAlerts(alerts.filter(a => a.id !== id)));
  };
  const getAlerts = (customer, location) => {
    API.alert.getAlerts(customer, location).then(({ data }) => {
      setAlerts(data.alerts);
    });
  };

  useEffect(() => {
    if (customer) {
      getAlerts(customer);
    }
  }, [customer]);

  return customer !== 'oxEe2oxuB0g4at7WgkMO' ? (
    <Container>
      <Header>Alerts aren&apos;t available for your account.</Header>
    </Container>
  ) : (
    <Container>
      <Table>
        <thead>
          <TableRow>
            <TableHeader>Location</TableHeader>
            <TableHeader>Parameter</TableHeader>
            <TableHeader>Check Type</TableHeader>
            <TableHeader>Value</TableHeader>
            <TableHeader></TableHeader>
            <TableHeader></TableHeader>
          </TableRow>
        </thead>
        <tbody>
          {alerts?.map(alert => (
            <TableRow key={alert.id}>
              <TableCell>
                <StyledSelect
                  value={alert.location}
                  onSelect={({ value }) =>
                    updateAlertItem(alert.id, 'location__name', value)
                  }
                  items={locations.map(item => ({
                    name: item.name,
                    value: item.id
                  }))}
                  placeholder={'Select parameter'}
                ></StyledSelect>
              </TableCell>
              <TableCell>
                <StyledSelect
                  value={alert.field}
                  onSelect={({ value }) => updateAlertItem(alert.id, 'field', value)}
                  items={fieldOptions.map(item => ({
                    name: item.name,
                    value: item.value
                  }))}
                  placeholder={'Select parameter'}
                ></StyledSelect>
              </TableCell>
              <TableCell>
                <StyledSelect
                  value={alert.check_type}
                  onSelect={({ value }) => updateAlertItem(alert.id, 'check_type', value)}
                  items={checkTypes.map(item => ({
                    name: item.name,
                    value: item.value
                  }))}
                  placeholder={'Select check type'}
                ></StyledSelect>
              </TableCell>
              <TableCell>
                <StyledInputText
                  type='number'
                  value={alert.threshold}
                  onChange={e => updateAlertItem(alert.id, 'threshold', e.target.value)}
                />
              </TableCell>
              <TableCell style={{ paddingLeft: '1rem' }}>
                <StyledButton
                  key={'save-' + alert.id}
                  onClick={() => updateAlert(alert.id, alert)}
                  disabled={!alert.modified || !alert.threshold}
                >
                  Save
                </StyledButton>
              </TableCell>
              <TableCell>
                <StyledButton
                  key={'delete-' + alert.id}
                  onClick={() => deleteAlert(alert.id, alert)}
                >
                  Delete
                </StyledButton>
              </TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell>
              <StyledSelect
                value={newAlert.location__name}
                onSelect={({ value }) =>
                  setNewAlert({ ...newAlert, location__name: value })
                }
                items={locations.map(item => ({
                  name: item.name,
                  value: item.id
                }))}
                placeholder={'Select parameter'}
              ></StyledSelect>
            </TableCell>
            <TableCell>
              <StyledSelect
                value={newAlert.field}
                onSelect={({ value }) => setNewAlert({ ...newAlert, field: value })}
                items={fieldOptions.map(item => ({
                  name: item.name,
                  value: item.value
                }))}
                placeholder={'Select parameter'}
              ></StyledSelect>
            </TableCell>
            <TableCell>
              <StyledSelect
                value={newAlert.check_type}
                onSelect={({ value }) => setNewAlert({ ...newAlert, check_type: value })}
                items={checkTypes.map(item => ({
                  name: item.name,
                  value: item.value
                }))}
                placeholder={'Select check type'}
              ></StyledSelect>
            </TableCell>
            <TableCell>
              <StyledInputText
                type='number'
                value={newAlert.threshold}
                onChange={e => setNewAlert({ ...newAlert, threshold: e.target.value })}
              />
            </TableCell>
            <TableCell style={{ paddingLeft: '1rem' }}>
              <StyledButton
                onClick={addAlert}
                disabled={
                  !newAlert.location__name ||
                  !newAlert.field ||
                  !newAlert.check_type ||
                  !newAlert.threshold
                }
              >
                Add
              </StyledButton>
            </TableCell>
          </TableRow>
        </tbody>
      </Table>
    </Container>
  );
};
export default AlertsSettings;
